var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.141 55.3352C49.3822 54.9294 47.894 54.1176 46.4057 53.0352C43.6999 51.0058 41.941 47.8941 41.5352 44.5117C45.7293 46.947 49.1116 50.7352 51.141 55.3352Z",
    fill: "url(#paint0_linear_1138_15619)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.918 66.2934C44.5122 72.111 40.9945 77.3875 35.1769 79.8228C27.1945 83.2051 17.8592 79.2816 14.6122 71.2992C11.2298 63.3169 15.1533 53.9816 23.1357 50.5992C25.4357 49.6522 27.7357 49.2463 30.0357 49.3816C29.7651 48.164 29.4945 47.0816 29.3592 45.7287C29.2239 44.1051 29.0886 42.6169 29.2239 40.9934C27.6004 40.9934 26.1122 41.1287 24.4886 41.5345L21.5122 34.4992L25.0298 33.011C27.0592 32.1992 28.1416 29.764 27.1945 27.5992C26.2474 25.4345 23.8122 24.4875 21.7827 25.4345L18.2651 26.9228L16.371 22.4581C15.4239 20.0228 12.5827 18.9404 10.2827 19.8875C7.84745 20.8345 6.7651 23.5404 7.71215 25.9757L9.47098 30.4404L5.81804 31.9287C3.78863 32.7404 2.70627 35.1757 3.65333 37.3404C4.60039 39.5051 6.90039 40.4522 9.0651 39.5051L12.718 38.0169L15.6945 45.0522C6.49451 51.411 2.43568 63.5875 7.03568 74.411C12.1769 86.7228 26.2474 92.5404 38.5592 87.3992C46.8122 83.8816 52.2239 76.3051 53.171 68.0522C50.3298 67.9169 47.4886 67.2404 44.918 66.2934Z",
    fill: "url(#paint1_linear_1138_15619)",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4834 22.4588L86.3187 5.81759C86.1834 4.87053 85.7775 4.05877 84.9657 3.51759C84.2892 2.97641 83.3422 2.70582 82.3951 2.84112L65.6187 4.87053C63.7245 5.14112 62.3716 6.89994 62.6422 8.79406C62.9128 10.6882 64.6716 12.0411 66.5657 11.7705L73.4657 10.9588L64.9422 21.9176C55.201 17.047 43.0245 19.4823 36.1245 28.4117C28.2775 38.5588 30.0363 53.1705 40.1834 61.0176C50.3304 68.8646 64.9422 67.1058 72.7892 56.9588C79.6893 48.0293 79.1481 35.5823 71.9775 27.4646C72.654 26.6529 80.7716 16.0999 80.501 16.5058L81.3128 23.4058C81.5834 25.2999 83.3422 26.6529 85.2363 26.3823C87.2657 26.247 88.6187 24.4882 88.4834 22.4588ZM66.5657 52.0882C61.4245 58.7176 51.8187 59.9352 45.1893 54.7941C38.5598 49.6529 37.3422 40.047 42.4834 33.4176C47.6245 26.7882 57.2304 25.5705 63.8598 30.7117C70.4893 35.8529 71.7069 45.4588 66.5657 52.0882Z",
    fill: "url(#paint2_linear_1138_15619)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1138_15619",
    x1: 46.3381,
    y1: 44.5117,
    x2: 46.3381,
    y2: 56.2372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818181",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1138_15619",
    x1: 28.2388,
    y1: 19.5469,
    x2: 28.2388,
    y2: 95.0807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818181",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1138_15619",
    x1: 59.8616,
    y1: 2.80664,
    x2: 59.8616,
    y2: 71.1704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818181",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImg);
export default __webpack_public_path__ + "static/media/no-img.ff4770f16ddac0b0a005f4be90141ca3.svg";
export { ForwardRef as ReactComponent };